export const formFields311 = [
  {
    label: 'Τίτλος Επενδυτικού Σχεδίου',
    type: 'text',
    name: 'titlos',
    id: 'titlos',
    size: 'large',
    placeholder: 'Εισάγετε Τίτλο',
    span: 24,
    disabled: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Κ.Α.Δ. Επένδυσης',
    type: 'text',
    name: 'kwdikosKad',
    id: 'kwdikosKad',
    size: 'large',
    placeholder: 'Εισάγετε Κ.Α.Δ. Επένδυσης',
    span: 24,
    disabled: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
];

export const formFields3111 = [
  {
    label: 'Ημ. Έναρξης',
    type: 'text',
    name: 'enarksh',
    id: 'enarksh',
    size: 'large',
    placeholder: 'Εισάγετε Ημ. Έναρξης',
    className: 'w-100',
    span: 11,
    disabled: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Ημ. Ολοκλήρωσης',
    type: 'text',
    name: 'oloklhrwsh',
    id: 'oloklhrwsh',
    size: 'large',
    placeholder: 'Εισάγετε Ημ. Ολοκλήρωσης',
    className: 'w-100',
    span: 11,
    disabled: true,
    rules: [
      // { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
      // () => ({
      //   validator(_, value) {
      //     return validateDateCompletion(value);
      //   },
      // }),
    ],
  },
]


export const formFields3112 = [
  {
    label: 'Σύντομη Περιγραφή',
    type: 'textarea',
    name: 'perigrafi',
    id: 'perigrafi',
    size: 'large',
    options: [],
    placeholder: 'Εισάγετε Σύντομη Περιγραφή',
    span: 24,
    disabled: true,
    rows: 10,
    autoSize: { minRows: 17 },
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
]

// Needed as user inputs atm: formFields3121
export const checkboxes311 = [
  {
    label: 'Αναπτυξιακός Νόμος',
    name: 'investmentFinancing',
    id: 'investmentFinancing',
    type: 'checkbox',
    span: 24,
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
    ],
    financingValue: [{
      // label: <span style={{ color: "white"}}>Αναπτυξιακός Νόμος</span>,
      name: 'investmentFinancingValue',
      id: 'investmentFinancingValue',
      type: 'formattedNumber',
      placeholder: 'Εισάγετε Ποσό',
      size: 'large',
      // right: true,
      className: 'formattedNumberField',
      span: 24,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    }]
  },
  {
    label: 'Άλλο Καθεστώς Ενίσχυσης',
    name: 'otherInvestmentFinancing',
    id: 'otherInvestmentFinancing',
    type: 'checkbox',
    span: 24,
    rules: [
      {
        type: 'boolean',
        transform: value => value || undefined,
      },
    ],
    financingValue: [{
      // label: <span style={{ color: "white"}}>Άλλο Καθεστώς Ενίσχυσης</span>,
      name: 'otherInvestmentFinancingValue',
      id: 'otherInvestmentFinancingValue',
      type: 'formattedNumber',
      placeholder: 'Εισάγετε Ποσό',
      size: 'large',
      span: 24,
      // right: true,
      className: 'formattedNumberField',
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    }]
  },
];

export const formFields3121 = [
  {
    label: <span style={{ color: "white" }}>Αναπτυξιακός Νόμος</span>,
    name: 'investmentFinancing',
    id: 'investmentFinancing',
    type: 'formattedNumber',
    // placeholder: 'Εισάγετε Ποσό',
    size: 'large',
    right: true,
    className: 'formattedNumberField',
    span: 24,
    asterisk: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    // label: <span style={{ color: "white"}}>Αναπτυξιακός Νόμος</span>,
    name: 'investmentFinancing',
    type: 'formattedNumber',
    // placeholder: 'Εισάγετε Ποσό',
    size: 'large',
    span: 24,
    asterisk: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: <span style={{ color: "white" }}>Άλλο Καθεστώς Ενίσχυσης</span>,
    name: 'otherInvestmentFinancing',
    type: 'formattedNumber',
    // placeholder: 'Εισάγετε Ποσό',
    size: 'large',
    span: 24,
    right: true,
    className: 'formattedNumberField',
    asterisk: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    // label: <span style={{ color: "white"}}>Άλλο Καθεστώς Ενίσχυσης</span>,
    name: 'otherInvestmentFinancing',
    type: 'formattedNumber',
    // placeholder: 'Εισάγετε Ποσό',
    size: 'large',
    span: 24,
    asterisk: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  }
];

export const formFields312 = [
  {
    label: 'Περιφέρεια',
    type: 'text',
    name: 'periferia',
    id: 'periferia',
    placeholder: 'Εισάγετε Περιφέρεια',
    size: 'large',
    span: 24,
    disabled: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Περιφερειακή Ενότητα',
    type: 'text',
    name: 'periferiakiEnotita',
    id: 'periferiakiEnotita',
    size: 'large',
    placeholder: 'Εισάγετε Περιφερειακή Ενότητα',
    span: 24,
    disabled: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Δήμος',
    type: 'text',
    name: 'dimos',
    id: 'dimos',
    size: 'large',
    placeholder: 'Εισάγετε Δήμο',
    span: 24,
    disabled: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
  {
    label: 'Τόπος Υλοποίησης',
    type: 'text',
    name: 'topos',
    id: 'topos',
    size: 'large',
    options: [],
    placeholder: 'Εισάγετε Τόπο Υλοποίησης',
    span: 24,
    disabled: true,
    // rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
  },
];
